export default __webpack_public_path__ + "static/media/Icons_Move_Regular.93b060c4.svg";